var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image-viewer',{attrs:{"on-close":_vm.close,"url-list":[_vm.imgUrl]}})
}
var staticRenderFns = []

export { render, staticRenderFns }